import * as React from 'react';
import { Spin } from 'antd';

interface iProps {
    enabled?: boolean; // isLoading
    debounce?: number; // delay time
    children?: any;
    wrapperClassName?: string;
}

export default class Loading extends React.Component<iProps> {
    static defaultProps = {
        enabled: true,
        debounce: 0
    };

    render() {
        let { enabled, debounce, children, wrapperClassName } = this.props;
        // wrap the children with spin or just set spin there
        return children
            ? <Spin spinning={enabled} delay={debounce} wrapperClassName={wrapperClassName}>
                {children}
            </Spin>
            : <div className="Loading">
                <Spin spinning={enabled} delay={debounce} />
            </div>;
    }
}
